import { isRequired } from '@shared/utils/CustomErrors'

import useBackend from '@shared/hooks/useBackend'

import config from '@shared/config'

function salesAssistant() {
  // HOOKS
    const { doGet, doPost, setup } = useBackend()


  // INIT
  setup('ovpv3/public', config.microserviceBaseUrl)

  // METHODS
  async function getInsurers(passthrough = [], insuranceType = 'KVG') {
    const response = await doGet({
      url: '/sales-assistant/insurers',
      params: {
        insuranceType: insuranceType
      },
      passthrough
    })

    return response.data.insurers
  }

  async function getInsurerProducts({ insurer, language, passthrough = [] }) {
    const response = await doGet({
      url: `/sales-assistant/insurers/${insurer}/products`,
      params: { language: language.toUpperCase() },
      passthrough
    })

    return response.data.products
  }

  async function mapProducts(payload, passthrough = []) {
    const response = await doPost({
      url: `/sales-assistant/product-mapping`,
      data: payload,
      passthrough,
    })

    return response.data
  }

  async function uploadPolicy(file = isRequired('file'), passthrough) {
    const formData = new FormData()
    formData.append('competitorPolicy', file, file.name.replace('=', '_'))

    const response = await doPost({
      url: `/sales-assistant/competitor-policy`,
      data: formData,
      passthrough,
      config: {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    })
    return response.data
  }

  return {
    getInsurers,
    getInsurerProducts,
    mapProducts,
    uploadPolicy,
  }
}

export default salesAssistant()